import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api, getErrorMessage } from "@/lib/api";
import AuthShell from "./AuthShell";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(getErrorMessage(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title="Mot de passe oublié ?"
      subtitle="Entrez votre adresse e-mail, nous enverrons un lien de réinitialisation."
    >
      {sent ? (
        <div className="border border-[#002FA7]/30 bg-[#002FA7]/5 p-6" data-testid="forgot-sent">
          <div className="text-sm text-zinc-700">
            Si un compte existe pour <span className="font-mono">{email}</span>, un e-mail de
            réinitialisation a été envoyé. Vérifiez votre boîte de réception.
          </div>
          <Link
            to="/login"
            className="inline-block mt-4 text-sm text-[#002FA7] hover:underline"
          >
            ← Retour à la connexion
          </Link>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-5" data-testid="forgot-form">
          <label className="block">
            <span className="block text-[11px] uppercase tracking-[0.15em] text-zinc-500 font-mono mb-2">
              Adresse e-mail
            </span>
            <input
              data-testid="forgot-email"
              type="email"
              required
              maxLength={200}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-white border border-zinc-300 px-4 py-2.5 text-sm focus:border-[#002FA7] focus:ring-1 focus:ring-[#002FA7] outline-none"
            />
          </label>
          <button
            data-testid="forgot-submit"
            disabled={loading}
            className="w-full bg-[#002FA7] hover:bg-[#00227A] text-white text-sm font-medium py-3 transition-colors disabled:opacity-50"
          >
            {loading ? "Envoi..." : "Envoyer le lien"}
          </button>
          <Link
            to="/login"
            className="inline-block text-xs text-zinc-600 hover:text-[#002FA7]"
          >
            ← Retour à la connexion
          </Link>
        </form>
      )}
    </AuthShell>
  );
}
